import { useTranslation } from '@eti/providers';
import { SMS } from '../../products';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { jsx as _jsx } from "react/jsx-runtime";
const texts = {
  additionalInformation: 'smsAdditionalInformation',
  persuasionContent: 'smsPersuasionContent',
  readMoreContent: 'smsReadMoreModalContent',
  text: 'smsAbstractSmallCard',
  title: 'smsTitle',
  upSell: 'smsUpSellText'
};
const SmallSms = _ref => {
  let {
    form,
    isSelected,
    order
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    text,
    readMoreContent,
    title
  } = getTranslatedTexts(texts, t);
  return /*#__PURE__*/_jsx(SmallCardLayout, {
    description: text,
    form: form,
    isSelected: isSelected,
    order: order,
    productId: SMS.id,
    productName: SMS.name,
    readMoreContent: readMoreContent,
    title: title
  });
};
export default SmallSms;